import { render, staticRenderFns } from "./ContractTac.vue?vue&type=template&id=3b775e26"
import script from "./ContractTac.vue?vue&type=script&lang=js"
export * from "./ContractTac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports